export default "__VITE_ASSET__arp0Pv$W__"